<template>
  <div
    v-if="getAppLoading"
    class="  h-[500px] flex justify-center items-center"
  >
    <app-loader></app-loader>
  </div>
  <div v-else class="mt-7">
    <v-sheet max-width="" class="bg-transparent mb-7">
      <overview-heading></overview-heading>
  
      <v-row class="justify-space-between">
        <v-col>
        </v-col>
        <v-col cols="2">
          <div>
            
            <app-primary-button
              v-if="isEditButton"
              :buttonLabel="$t('requestFundsTab.requestFund')"
              @click="showRequestNewFundTab(false)"
            >
              <template #icon>
                <v-icon icon="mdi-plus"></v-icon>
              </template>
            </app-primary-button>
          </div>
        </v-col>
      </v-row>
      <!-- <RequestOverview :overviewData="getOverviewStats"/> -->
      <funds-table
        class="mt-7"
        mode="view"
        :overViewData="getOverviewStats"
        :hideInput="true"
      ></funds-table>

      <app-custom-table
        class="mt-7"
        title="All Fund Requests"
        :headers="tableHeaders"
        :items="items"
        show-menu
        show-total
        :dropdown-options="['View']"
        @menu-click="showDialog($event)"
        :currency-symbol="getRequestedFundsCurrency"
        scroll-horizontally
      >
        <template #action-btn>
          <app-single-select
            id="filter-status"
            class="mt-n4 w-[150px]"
            :labelPlaceholder="$t('requestFundsTab.selectStatus')"
            :options="statuses"
            v-model="status"
          >
          </app-single-select>
        </template>
        <template #approved_status="{item}">
          <p
            :class="[
              'px-2 py-1 rounded-md text-center',
              item?.pending_to?.toLowerCase() === 'paid' ? 'text-[#027a48] bg-green-200' : 'text-[#b54708] bg-[#FEEBC8]',
            ]"
          >{{item?.pending_to?.toLowerCase() === "paid" ? "Paid" : item?.approved_status}}</p>
        </template>
        <template #period="{item}">
          <p>{{item?.start_date?.formattedDate()}} - {{item?.end_date?.formattedDate()}}</p>
        </template>
        <template #approved_amount="{item}">
          <div
            class="relative inline-block"
          >
            <div class="flex items-center gap-2">
              <p>{{item?.approved_amount?.germanCurrencyFormatter()}}</p>
              <v-icon
                v-if="item?.comments?.length > 0"
                icon="custom:info"
                @mouseenter="itemToShow = item?.index"
                @mouseleave="itemToShow = null"
              ></v-icon>
            </div>

            <div
              v-if="itemToShow === item?.index"
              class="bg-white w-max min-w-[200px] absolute top-full left-0 mt-1 z-30 flex flex-col justify-between items-start shadow-lg rounded-lg text-base"
            >
              <div
                v-for="(comment, i) in item?.comments"
                :key="i"
                class="w-full text-no-wrap px-4 py-1 hover:bg-gray-50 transition-colors ease-in-out duration-300 text-sm"
              >
                <h1
                  class="font-sans font-semibold text-left text-gray-900"
                >
                  {{ comment?.author }}
                </h1>
                <p
                  class="font-sans font-normal text-left text-gray-500"
                >
                  {{ comment?.comment }}
                </p>
              </div>
            </div>
          </div>
        </template>

        <template #invoice_number="{item}">
          <p @click="handleInvoiceClick(item)" class="text-blue-500 hover:text-blue-600 cursor-pointer hover:underline w-max">{{item?.pending_to?.toLowerCase() === "paid" ? item?.invoice_number : $t("Open".getTranslationKey())}}</p>
        </template>
      </app-custom-table>
    </v-sheet>
    <app-dialog
      ref="dialogState"
      :title="$t('requestFundsTab.viewFundDetails')"
      subTitle=""
      :width="1300"
    >
      <template #content>
        <div>
          <v-sheet max-width="" class="bg-transparent">
            <v-row class="justify-space-between">
              <v-col>
                <div
                  class="flex items-center h-full text-xl font-semibold leading-7 text-left text-gray-900 font-inter"
                >
                  {{ $t("requestFundsTab.period") }}
                </div>
              </v-col>
              <v-col cols="2">
                <div></div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4">
                <app-date-picker
                  :label="$t('leaves.startDate')"
                  type="date"
                  :disabled="true"
                  :modelValue="getOneRequestedFundPeriod?.start_date"
                >
                </app-date-picker>
              </v-col>
              <v-col cols="4">
                <app-date-picker
                  :label="$t('leaves.endDate')"
                  type="date"
                  :disabled="true"
                  :modelValue="getOneRequestedFundPeriod?.end_date"
                >
                </app-date-picker>
                {{ getOneRequestedFund?.end_date }}
              </v-col>
            </v-row>

            <v-row class="mt-4 pa-0">
              <v-col>
                <div>
                  <funds-table
                    mode="view"
                    :overViewData="getOneOverviewStats"
                  ></funds-table>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-4 pa-0">
              <v-col>
                <div>
                  <budget-item-table
                    mode="view"
                    :data="getOneRequestedFund.request_items"
                    :tableStats="getOneTableStats"
                  ></budget-item-table>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </div>
      </template>
      <template #actions>
        <v-row class="flex justify-end px-4 mt-1 mb-5">
          <v-col cols="1" class="">
            <app-primary-button
              :buttonLabel="$t('employees.cancel')"
              @click="hideDialog()"
              class="cursor-pointer"
            >
            </app-primary-button>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
    <app-dialog
      ref="dialog"
      :title="deleteTitle"
      :subtitle="deleteSubTitle"
      height="302"
      width="408"
    >
      <template #actions>
        <v-row class="px-4 mb-5">
          <v-col cols="6" class="">
            <app-secondary-button
              :buttonLabel="$t('employees.noKeepIt')"
              @click-event="hideDialog()"
            >
            </app-secondary-button>
          </v-col>
          <v-col cols="6" class="">
            <v-btn
              variant="default"
              min-width="100%"
              min-height="100%"
              class="bg-[#D92D20] text-white !normal-case rounded-lg font-['Open_Sans'] text-[1rem] font-normal"
              @click="delContractTask"
            >
              <!-- Yes , delete -->
              {{ $t("employees.yesDelete") }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </app-dialog>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import FundsTable from "./requestedFunds/FundsTable.vue";
import BudgetItemTable from "./requestedFunds/BudgetItemTable.vue";
import OverviewHeading from "@/components/dashboard/projects/pm-local/projectOverview/OverviewHeading.vue";
export default defineComponent({
  name: "RequestedFunds",
  components: {
    OverviewHeading,
    //  RequestOverview,
    FundsTable,
    BudgetItemTable,
  },
  data() {
    return {
      statuses: [
        {
          text: "All",
          value: "",
        },
        {
          text: "Pending",
          value: "Pending",
        },
        {
          text: "Approved",
          value: "Approved",
        },
        {
          text: "Disapproved",
          value: "Disapproved",
        },
      ],
      dialogState: false,
      dialog: false,
      deleteTitle: "Delete Task?",
      deleteSubTitle:
        "Are you sure you want to delete this task? This action can’t be undone.",
      status: "",
      tableHeaders: [
        {key: "number", label: "Sr. No."},
        {key: "invoice_number", label: "No. Incoming Invoice"},
        {key: "total_requested_amount", label: "Requested Amount", type: "currency"},
        {key: "reduced_amount", label: "Reduction", type: "currency"},
        {key: "approved_amount", label: "Approved Amount", type: "currency"},
        {key: "approved_status", label: "Status"},
        {key: "period", label: "Period"},
        {key: "transfer_date", label: "Transfer Date", type: "date"},
        {key: "transfered_to", label: "Transfer Via"},
      ],
      itemToShow: null,
    };
  },
  computed: {
    ...mapGetters("pmLocalRequestFund", [
      "getAppLoading",
      "getAllRequestedFunds",
      "getOverviewStats",
      "getOneRequestedFund",
      "getOneTableStats",
      "getOneOverviewStats",
      "getOneRequestedFundPeriod",
      "getRequestedFundsCurrency"
    ]),
    currentTab() {
      return this.$store.getters["commonResources/isCurrentTab"];
    },
    foreignEstablishment() {
      return this.$store.getters["pmLocalModules/isForeignEstablishmentID"];
    },
    items() {
      return this.getAllRequestedFunds?.map((requestedFund, index) => {
        return {
          id: requestedFund?.id,
          "number": index + 1,
          ...requestedFund,
        };
      });
    },
 
    isEditButton() {
      return this.$store.getters["hrResources/isEditButton"] 
    },
    ...mapState(["translation"]),
  },
  watch: {
    async status(newstatus) {
      await this.fetchAllRequestedFunds({
        foreignEstablishment: this.foreignEstablishment,
        status: newstatus,
      });
    },
  },
  methods: {
    ...mapActions("pmLocalRequestFund", [
      "fetchAllRequestedFunds",
      "fetchOneRequestedFund",
    ]),
    handleInvoiceClick(item) {
      if(item?.pending_to?.toLowerCase() === "paid") {
        this.viewRequestedFundPDF(item);
      } else if(item?.approved_status?.toLowerCase() === "pending") {
        this.$store.commit("pmLocalRequestFund/SET_REQUESTED_FUND_ID", item.id);
        this.showRequestNewFundTab(true);
      } else {
        this.showDialog(item);
      }
    },
    showRequestNewFundTab(isEdit = false) {
      this.$store.commit("pmLocalRequestFund/SET_EDIT_MODE", isEdit);
      this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", true);
      this.$store.commit("commonResources/SET_CURRENT_TAB_TO_STATE", this.currentTab + 1);
    },
    hideDialog() {
      this.$refs.dialogState.showDialog = false;
      this.$refs.dialog.showDialog = false;
    },
    viewRequestedFundPDF(payload) {
      this.$store.commit("pmLocalRequestFund/SET_REQUESTED_FUND_ID", payload.id);
      this.$router.push({name: "viewProjectFund"})
    },
    async showDialog(payload) {
      await this.fetchOneRequestedFund({ foreignEstablishment: payload?.id });
      this.$refs.dialogState.showDialog = true;
    },
  },
  async mounted() {
    this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", false);
    await this.fetchAllRequestedFunds({
      foreignEstablishment: this.foreignEstablishment,
      status: "",
    });

  },
});
</script>
